module.exports = __webpack_public_path__ + "img/background24.56af01e2.jpg";